export default __webpack_public_path__ + "static/media/project1.6257667c.jpg";